import { Skeleton } from "@au-schein-de/au-ui-library";

export function ProductCardSkeleton() {
	return (
		<div
			className="flex flex-col items-start"
			data-testid="product-list-item-skeleton"
		>
			<Skeleton className="w-full h-73 mb-2 bg-gray-200 rounded-xl" />
			<div className="flex flex-row justify-start gap-2">
				<Skeleton className="w-19 h-5 mb-2 bg-gray-200" />
				<Skeleton className="w-19 h-5 mb-2 bg-gray-200" />
			</div>
			<Skeleton className="w-58 h-4 mb-2 bg-gray-200" />
			<Skeleton className="w-49 h-10 mb-2 bg-gray-200" />
		</div>
	);
}
